// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__tuM2H","boxTitle":"Qualiphy_boxTitle__3DM_A","box":"Qualiphy_box__1Vl0F","toggleWrap":"Qualiphy_toggleWrap__2iw8h"};